export default function CurrentTask({currentTask}: {currentTask: string}) {
  return <>
    {currentTask}
  </>
}